// extracted by mini-css-extract-plugin
export var btn = "QuickLinks-module--btn--e7e64";
export var btnIcon = "QuickLinks-module--btnIcon--d8f73";